import { Box } from '@radix-ui/themes'

/**
 * Wrapper for static prose/markdown content pages.
 * Keeps content centered with a readable max-width and applies Tailwind
 * Typography styles for rendered markdown.
 */
export function ProseContent({ children }: { children: React.ReactNode }) {
  return (
    <Box className="mx-auto max-w-2xl">
      <div className="prose prose-sm dark:prose-invert max-w-none">
        {children}
      </div>
    </Box>
  )
}
